import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const UserFooter = () => {
  return (
    <div className="fixed bottom-0 left-0 w-full bg-[#CCCCCC] p-4">
      <div className="flex  justify-around items-center   font-userFont ">
        <div className="flex flex-col space-y-6">
          <p>Call</p>
          <p className="font-semibold">123-456-7890</p>
        </div>
        <div className="flex flex-col space-y-6">
          <p>Email</p>
          <p className="font-semibold">info@example.com</p>
        </div>
        <div className="flex flex-col space-y-6">
          <p>Follow</p>
          <div className="font-semibold flex space-x-4">
            <Icon fontSize={25} icon="ic:baseline-facebook" />
            <Icon fontSize={25} icon="mdi:twitter" />
            <Icon fontSize={25} icon="mdi:linkedin" />
            <Icon fontSize={25} icon="mdi:instagram" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFooter;
